import { Column, Entity, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ProcessNoteEntity } from './process-note.entity';
import { ProcessObjectEntity } from './process-object.entity';
import { ProcessTaskDefinitionEntity } from './process-task-definition.entity';
import { ProcessEntity } from './process.entity';

@Entity('process_definition')
export class ProcessDefinitionEntity extends BaseEntity {
	@Column('varchar', { name: 'name', length: 255 })
	public name!: string;

	@Column('varchar', { name: 'description', nullable: true, length: 255 })
	public description!: string | null;

	@Column('int', { name: 'repeatInterval', nullable: true })
	public repeatInterval!: number | null;

	@Column('tinyint', {
		name: 'isRepeatIntervalNeeded',
		width: 1,
		default: () => "'0'",
	})
	public isRepeatIntervalNeeded!: boolean;

	@OneToMany(() => ProcessEntity, (process) => process.fkProcessDefinition, {})
	public processes!: Array<ProcessEntity>;

	@OneToMany(
		() => ProcessNoteEntity,
		(processNote) => processNote.fkProcessDefinition,
		{},
	)
	public processNotes!: Array<ProcessNoteEntity>;

	@OneToMany(
		() => ProcessObjectEntity,
		(processObject) => processObject.fkProcessDefinition,
		{},
	)
	public processObjects!: Array<ProcessObjectEntity>;

	@OneToMany(
		() => ProcessTaskDefinitionEntity,
		(processTaskDefinition) => processTaskDefinition.fkProcessDefinition,
		{},
	)
	public processTaskDefinitions!: Array<ProcessTaskDefinitionEntity>;
}
